module.exports = __webpack_public_path__ + "img/magnusLogin.a7a6df09.svg";